export function splitAddressNumber(value) {
  const raw = String(value || '').trim()
  if (!raw) return { address: '', address_number: '' }

  const parts = raw.split(',')
  if (parts.length < 2) return { address: raw, address_number: '' }

  const lastPart = parts[parts.length - 1].trim()
  const numberPattern = /^(?:s\/n|sn|\d+[a-zA-Z0-9\-/]*)$/i
  if (!numberPattern.test(lastPart)) {
    return { address: raw, address_number: '' }
  }

  return {
    address: parts.slice(0, -1).join(',').trim(),
    address_number: lastPart,
  }
}

export function composeAddress(address, addressNumber) {
  return [String(address || '').trim(), String(addressNumber || '').trim()].filter(Boolean).join(', ')
}